import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import Pagination from '../../components/Pagination';
import {
  formatAmount,
  formatOptionalId,
  formatRoleId,
} from './memberConstants';

export default function MemberInviterTreeModal({ open, row, onClose }) {
  const [direction, setDirection] = useState('UP');
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !row?.id) {
      return;
    }
    loadRecords(direction, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, row?.id, direction]);

  async function loadRecords(nextDirection, pageNo) {
    setLoading(true);
    setError('');
    try {
      const data = await adminApi.memberInviterTree({
        memberId: row.id,
        direction: nextDirection,
        pageNo,
        pageSize: 15,
      });
      setRecords(data?.records || []);
      setPage(data?.current || pageNo);
      setTotalPages(data?.pages || 1);
    } catch (err) {
      setError(err.message || '載入失敗');
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }

  if (!open || !row) {
    return null;
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>查看上下級 [{formatOptionalId(row.id)}]</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="admin-modal__body">
          <div className="member-inviter-tabs">
            <button
              type="button"
              className={direction === 'UP' ? 'is-active' : ''}
              onClick={() => setDirection('UP')}
            >
              上級
            </button>
            <button
              type="button"
              className={direction === 'DOWN' ? 'is-active' : ''}
              onClick={() => setDirection('DOWN')}
            >
              下級
            </button>
          </div>
          {loading && <p>載入中…</p>}
          {error && <div className="alert alert-error">{error}</div>}
          <div className="table-scroll">
            <table className="data-table">
              <thead>
                <tr>
                  <th>用戶ID</th>
                  <th>帳號類型</th>
                  <th>直屬上級用戶ID</th>
                  <th>層級</th>
                  <th>用戶層級</th>
                  <th>用戶郵箱/手機號</th>
                  <th>首存金額</th>
                  <th>可提款金額</th>
                  <th>鎖倉額度</th>
                  <th>充值總額</th>
                </tr>
              </thead>
              <tbody>
                {!loading && records.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="empty-cell">
                      尚無資料
                    </td>
                  </tr>
                ) : (
                  records.map((item) => (
                    <tr key={item.id}>
                      <td>{formatOptionalId(item.id)}</td>
                      <td>{formatRoleId(item.roleId)}</td>
                      <td>{formatOptionalId(item.inviterId)}</td>
                      <td>{item.level ?? '—'}</td>
                      <td>{item.memberLevel ?? '—'}</td>
                      <td>{item.emailOrPhone || '—'}</td>
                      <td>{formatAmount(item.firstDepositAmount)}</td>
                      <td>{formatAmount(item.withdrawableBalance)}</td>
                      <td>{formatAmount(item.lockedAmount)}</td>
                      <td>{formatAmount(item.depositAmount)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <Pagination page={page} totalPages={totalPages} onChange={(p) => loadRecords(direction, p)} />
        </div>
        <div className="admin-modal__footer">
          <button type="button" className="btn btn-danger" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
